import { render, staticRenderFns } from "./Frame.vue?vue&type=template&id=340f3cbd&lang=pug&"
import script from "./Frame.vue?vue&type=script&lang=ts&"
export * from "./Frame.vue?vue&type=script&lang=ts&"
import style0 from "./Frame.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports